import React from 'react';
import './Features.css';
import prescriptionIcon from '../prescription.png'; 
import { GiMedicines } from "react-icons/gi";
import { MdHistory } from "react-icons/md";
import { GrSecure } from "react-icons/gr";
import { GrUserManager } from "react-icons/gr";
import { AiOutlineGlobal } from "react-icons/ai";
import { FaPrescription } from "react-icons/fa6";

const Features = () => {
  const features = [
    {
      icon: <FaPrescription />,
      title: 'AI-Based Prescription Generation',
      description: 'Advanced AI algorithms analyze patient data to generate personalized diabetes treatment plans including medication dosages, timing, and combinations.'
    },
    {
      icon: <AiOutlineGlobal />,
      title: 'International Standards Compliance',
      description: 'All recommendations are built on international standards, ensuring evidence-based and up-to-date treatment protocols.'
    },
    {
      icon: <GrUserManager />,
      title: 'Easy Patient Management',
      description: 'Streamlined interface designed specifically for healthcare professionals to efficiently manage patient records and treatment histories.'
    },
    {
      icon: <GrSecure />,
      title: 'Secure OTP-Based Login',
      description: 'Enterprise-grade security with OTP authentication ensures only authorized medical professionals can access patient data.'
    },
    {
      icon: <MdHistory />,
      title: 'Simplified Patient History Tracking',
      description: 'Comprehensive yet intuitive tracking of patient progress, medication adherence, and treatment outcomes over time.'
    },
    {
      icon: <GiMedicines />,
      title: 'Comprehensive Treatment Plans',
      description: 'Generate complete treatment packages including medication, lifestyle modifications, dietary recommendations, and follow-up schedules.'
    }
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <div className="features-header text-center mb-6">
          <h2 className="features-title">Key Features</h2>
          <p className="features-subtitle">
            Everything healthcare professionals need to provide optimal diabetes care
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
